import { render, staticRenderFns } from "./moneyRecord.vue?vue&type=template&id=b86d5dd0&scoped=true&"
import script from "./moneyRecord.vue?vue&type=script&lang=js&"
export * from "./moneyRecord.vue?vue&type=script&lang=js&"
import style0 from "./moneyRecord.vue?vue&type=style&index=0&id=b86d5dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86d5dd0",
  null
  
)

export default component.exports